import React, { useCallback } from 'react'
import useClientLocation from '../../../hooks/use-client-location'
import { get } from 'lodash'
import useCourse from '../../../hooks/use-course'
import useCurrentUser from '../../../hooks/use-current-user'
import Modal from '../../modals/wrapper'
import { ExclamationCircle } from 'react-bootstrap-icons'
import { Button } from 'react-bootstrap'
import useToasts from '../../../hooks/use-toasts'
import useCourseEnrollment from '../../../hooks/use-course-enrollment'

const DropExperienceScreen = () => {
    const { goBack, params } = useClientLocation()
    
    const experienceId = get(params, 'experienceId')
    
    //  Get user
    const { id: userId } = useCurrentUser()
    
    //  Get course
    const {
        course: experience,
        isBusy: isLoading,
        isEnrolled,
    } = useCourse({
        id: experienceId,
    })

    //  setup toasts
    const {
        success: toastSuccess,
        error: toastError,
    } = useToasts({
        successMessage: 'Experience dropped!',
        onSuccess: goBack,
    })

    const { unenrollCourse, isBusy: isDropping } = useCourseEnrollment({
        userId,
        courseId: experienceId,
        onError: toastError,
        onSuccess: toastSuccess
    })
    
    return (
        <Modal
            closeButton
            onHide={goBack}
        >
            <div style={{ padding: '40px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around', height: '100%', paddingLeft: '10px', paddingRight: '10px'}}>
                    <div
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around'}}
                    >
                        <ExclamationCircle size={85} />
                    </div>
                    <div
                        style={{ padding: '35px'}}
                        className='text-center'
                    >
                        You are about to drop:<br/>
                        <strong>{experience ? experience.name : 'Loading...'}</strong>
                    </div>
                    <div>
                        <Button
                            block
                            disabled={isLoading}
                            onClick={() => unenrollCourse()}
                        >
                            YES, DROP THIS EXPERIENCE
                        </Button>
                        <Button
                            block
                            variant='outline-primary'
                            onClick={() => goBack()}
                        >
                            CANCEL
                        </Button>
                    </div>
                </div>
            
            </div>
        </Modal>
    )
}

export default DropExperienceScreen